import { useContext } from "react";
import { StaffContext } from "../context/context";

export const useCasters = () => {
  const context = useContext(StaffContext);
  return context;
};
